import styled from "styled-components";

const Headline = styled.h5<{ active?: boolean }>`
  text-align: center;

  font-weight: ${({ active }) => (active ? "bold" : "normal")};

  transition: all 0.6s cubic-bezier(0.25, 0.8, 0.25, 1);
  text-decoration: underline;
  text-decoration-color: ${({ active }) =>
    active ? "red" : "rgba(0,0,0,0.4)"};
`;

const Container = styled.section`
  @media print {
    [data-test="date-header-delete-all"] {
      display: none;
    }
  }
  display: inline-flex;
  justify-content: center;
`;

export default { Headline, Container };
